import React from 'react';
import styled from 'styled-components';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosAsync, cargarCatalogosGenericoAsync, cargarCatalogos } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf, generarReporteEnExcel } from '../../funciones_globales/interaccionApiReportes';
import { formatearNumeroEntero } from '../../funciones_globales/format';
import { cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

const LabelSub = styled.label`
    font-weight: 200;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

const Radio = styled.input`
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 7px;
    padding-right: 7px;
    padding-left: 7px;
`;

class FormInven06  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            periodo: '',
            mes_sel: null,
            mes_opt: [],
            bodega_sel: null,
            bodega_opt: [],
            proveedor_sel: null,
            linea_sel: null,
            articulo_desde_sel: null,
            articulo_hasta_sel: null,            
            anioActual: null,            
            opciones: 'S',
        };
        
        this.changeComponents = this.changeComponents.bind(this);        
        this.limpiar = this.limpiar.bind(this);
        this.generarRptExistenciaPorBodega = this.generarRptExistenciaPorBodega.bind(this);
        this.validarPeriodoSeleccionado = this.validarPeriodoSeleccionado.bind(this);
        this.validarMesSeleccionado = this.validarMesSeleccionado.bind(this);
    }

    changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        
        this.setState({[name]: value});
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo&tipoproveedor=I', cadena_busq, callback)
        }
    }

    getOptions_Articulos(input, callback){
        if (input.toString().length >= 2 ){
            let query = "?tipo=catalogo&cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/articulos', query, callback)
        }
    }

    getOptions_Marcas(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('LINEA', input, callback)
        }
    }

    validarPeriodoSeleccionado(){        
        try {            
            if(this.state.periodo!==''){
                let anio = formatearNumeroEntero(this.state.periodo);
                let fechaInf = formatearNumeroEntero(this.state.anioActual) - 3;
    
                if(anio>formatearNumeroEntero(this.state.anioActual)){
                    this.setState({periodo: formatearNumeroEntero(this.state.anioActual)});
                }else if(anio===formatearNumeroEntero(this.state.anioActual)){
                    this.setState({periodo: anio});
                }else if(anio >= fechaInf && anio <=formatearNumeroEntero(this.state.anioActual)){
                    this.setState({periodo: anio});
                }else{
                    this.setState({periodo: fechaInf});
                    alert(`Sólo puede consultar información de los últimos 3 años.`);
                }
            }   
        } catch (error) {
            alert(`Ocurrió un error al validar el periodo seleccionado. Error: ${error}`);
        }    
    }

    validarMesSeleccionado(){    
        try {
            let response = true;

            let fechaProceso = getFechaProcesoPorModulo('02');
            let mesActual = formatearNumeroEntero(fechaProceso.toString().split('/')[1]);
            let anioActual = formatearNumeroEntero(fechaProceso.toString().split('/')[2]);
            if( formatearNumeroEntero(this.state.periodo) === anioActual){
                if( formatearNumeroEntero(this.state.mes_sel) > mesActual){
                    alert(`Sólo puede consultar información hasta el periodo y mes actual.`);
                    response = false;
                }
            }
            return response;
        } catch (error) {
            alert(`Ocurrió un error al validar el mes seleccionado. Error: ${error}`);
            return false;
        }
    }

    componentDidMount(){
        Promise.all([            
            cargarCatalogos('BODEGA'),
            cargarCatalogos_Otros('MESES'),            
            this.props.generar_LogAuditoriaIngresoForm('0206')
         ])
        .then(([ bodegas, meses ]) => {
            let fechaProceso = getFechaProcesoPorModulo('02');

            if (fechaProceso !== null){
                let anioActual = fechaProceso.toString().split("/")[2];
                let mesActual = fechaProceso.toString().split("/")[1];                
                this.setState({ bodega_opt: bodegas, bodega_sel: '01', mes_opt: meses, anioActual: formatearNumeroEntero(anioActual),
                                periodo: parseInt(anioActual,10), mes_sel: mesActual });
            }
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0206');
    }    

    limpiar(){
        this.setState({
            bodega_sel: null,
            proveedor_sel: null,
            linea_sel: null,
            articulo_desde_sel: null,
            articulo_hasta_sel: null,
            opciones: 'S'
        });
    }

    generarRptExistenciaPorBodega(formatoReporte){
        try {                        

            var continuar = true;
            var error = "";
            var opcion = 'B'
            if(this.state.periodo==='' || this.state.mes_sel===null){
                continuar = false;
                error=error+"- Ingrese periodo y mes para la consulta."
            }

            if(this.state.periodo!=='' && this.state.mes_sel!==null){
                if(this.validarMesSeleccionado()===false){
                    continuar = false;
                }
            }
                
            if(this.state.bodega_sel!==null){            
                if(this.state.bodega_sel==='00'){
                    opcion = 'C'
                }
            }

            if(continuar === true){
                
                let rptUrlWithParams = `&param1=${opcion}&param2=${this.state.periodo}&param3=${this.state.mes_sel}`;
                if(this.state.bodega_sel!==null){
                    rptUrlWithParams += `&param4=${this.state.bodega_sel}`;
                }

                if(this.state.proveedor_sel!==null){
                    rptUrlWithParams += `&param5=${this.state.proveedor_sel.value}`;
                }

                if(this.state.linea_sel!==null){
                    rptUrlWithParams += `&param6=${this.state.linea_sel.value}`;
                }

                if(this.state.articulo_desde_sel!==null){
                    rptUrlWithParams += `&param7=${this.state.articulo_desde_sel.value}`;
                }

                if(this.state.articulo_hasta_sel!==null){
                    rptUrlWithParams += `&param8=${this.state.articulo_hasta_sel.value}`;
                }

                if(this.state.opciones!==null){
                    rptUrlWithParams += `&param9=${this.state.opciones}`;
                }
            
                if (formatoReporte==='PDF'){
                    rptUrlWithParams = `&rpt=24`.concat(rptUrlWithParams);
                    visualizarReporteEnPdf(rptUrlWithParams);
                }else{
                    rptUrlWithParams = `&rpt=48`.concat(rptUrlWithParams);                
                    generarReporteEnExcel(rptUrlWithParams);
                }
            }else if(error!==''){
                alert(error);
            }
        } catch (error) {
            alert(`Ocurrió un error al intentar generar el reporte. Error: ${error}`);
        }
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
                <HeaderForm>
                    <TituloForm>Existencia Bodega Valorizada</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row>                        
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Periodo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <InputText name='periodo' value={this.state.periodo} type="number" className='form-control input-sm'  
                            onChange={this.changeComponents} onBlur={this.validarPeriodoSeleccionado}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Mes:</LabelForm>
                        </ContainerCol>                
                        <ContainerCol className='col-sm-4' margen_abajo='4'>
                            <ReactSelect options={ this.state.mes_opt } value={this.state.mes_sel} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({mes_sel: value!==null?value.value:null})}}
                                func_onBlur={this.validarMesSeleccionado}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Bodega:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6' margen_arriba='15' margen_abajo='4'>
                            <ReactSelect options={ this.state.bodega_opt } value={this.state.bodega_sel}
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({bodega_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Proveedor:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6' margen_abajo='4'>
                            <ReactSelectAsync value={this.state.proveedor_sel} func_loadOptions={this.getOptions_Proveedores} 
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({proveedor_sel: value!==null?value:null})}}/>
                        </ContainerCol> 
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Marca:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6' margen_abajo='4'>
                            <ReactSelectAsync value={this.state.linea_sel}  func_loadOptions={this.getOptions_Marcas}
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({linea_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>                           
                        <ContainerCol className='col-sm-2' margen_abajo='4'>
                            <LabelForm>Art. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6' margen_abajo='4'>
                            <ReactSelectAsync value={this.state.articulo_desde_sel} func_loadOptions={this.getOptions_Articulos}
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({articulo_desde_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Art. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-6' margen_abajo='4'>
                            <ReactSelectAsync value={this.state.articulo_hasta_sel} func_loadOptions={this.getOptions_Articulos}
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null}; this.setState({articulo_hasta_sel: value!==null?value:null})}}/>
                        </ContainerCol>                    
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba='15'>
                            <LabelSub><Radio name="opciones" type='radio' disabled={false} value='S' onChange={this.changeComponents} checked={this.state.opciones==='S'?true:false}/>{'Sólo Artículos con Existencia'}</LabelSub>
                            <LabelSub><Radio name="opciones" type='radio' disabled={false} value='N' onChange={this.changeComponents} checked={this.state.opciones==='N'?true:false}/>{'Incluir Artículos sin Existencia'}</LabelSub>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={()=>{this.generarRptExistenciaPorBodega('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type='button' className='btn btn-success btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={()=>{this.generarRptExistenciaPorBodega('EXCEL')}}><i className="fa fa-file-excel-o fa-lg" aria-hidden="true"/> Generar Excel</button>
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
 
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
export default connect (null, mapDispatchToProps)(FormInven06);